import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "GledaliÅ¡Äe",
  "description": "",
  "published": "2006-10-02T00:00:00.000Z",
  "redirect_from": ["/blog/gledalie/swizec/379"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Tu je stal preÄudovit tekst, ki pa ga je hudobni browser popapcal za kosilo, ali pa je bila mogoÄe veÄerja, kdo bi vedel. Preberete si lahko angleško verzijo, Äe le znate priti do nje in jo razumeti.`}</p>
    <p>{`SovraÅ¾im izginotja...`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      